/**
 * Vue的自定义指令封装
 * 这个需要在入口src/main.js 注入一下
 */

import infinite from 'directives/infinite.js';
import swiperDirection from 'directives/swiperDirection.js';
import orientationChange from 'directives/orientationChange.js';
import clickOutSide from 'directives/clickoutside.js';

/**
 * 指令集合
 * @type {Array}
 */ 
const DIRECTIVE_LIST = [
  // 无限滚动
  infinite,

  // 手机方向
  swiperDirection,

  // 屏幕发生变化
  orientationChange,

  // 外部点击
  clickOutSide
];

export default {
  /**
   * 初始化自定义指令
   */
  init (Vue) {
    DIRECTIVE_LIST.forEach(directive => {
      Vue.directive(directive.name, directive)
    })

  }
};
